<template>
    <div>
        <div class="modal-backdrop show"></div>
        <div class="modal d-block" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('add_condicion_detail') }}</h5>
                        <button type="button" class="close" @click="$emit('close')">
                        <span>&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <label for="condition" class="required">Product type</label>
                        <app-input 
                            :placeholder = "$t('select_country_phd')" 
                            type = "advance-search-select"
                            fetch-url = "/product_type/serverside/selectable-name"
                            listValueField = "name"
                            v-model = "condition" 
                            :loaded-per-time = "5" 
                            :required = "true"  
                            :disabled="true"
                        />
                        <br>
                        <label for="code" class="required">Doc control</label>
                        <app-input
                            type="search-select" 
                            v-model="doc_control" 
                            :required="true" 
                            :list="list" 
                            :placeholder="$t('doc control')"
                            :disabled="true"
                        />
                        <br>
                        <label for="description" class="required">Description</label>
                        <div v-if="isDataLoaded"> 
                            <app-input  type="text-editor" v-model="description" :minimal="true"/>
                        </div>
                        <br>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="$emit('close')">
                            Close
                        </button>
                        &nbsp;
                        <button type="button" class="btn btn-primary" @click="submit">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>

import { getDetail } from "./api/api";

export default {
    name: "EditDetail",
    props :{
        id: {
            type: String|Number,
            default: null
        },
    },
    data() {
        return {
            condition: "",
            doc_control : "",
            description : "",
            description_id : null,
            list : [
                {id : 1, value : "PO"}, 
                {id : 2, value : "SO"}
            ],
            isDataLoaded : false,
        };
    },
    methods: {
        submit() {
            const data = {
                id_condition : this.description_id,
                description : this.description,
            }
            this.$emit("save", data);
        },

        async getData(id) {
            const res = await getDetail(id);
            if (res.data) {
                const doc = (this.doc_control === 'PO') ? 1 : 2;
                const data = res.data;
                this.condition = {id : data.product_type_id, name : data.product_type};
                this.doc_control = doc;
                this.description = data.description;
                this.description_id = data.description_id;
                this.isDataLoaded = true;
            }
        }
    },
    mounted(){
        if (this.id) {
            this.getData(this.id);
        }
    }
};
</script>
  